import React, { useEffect, useState } from 'react';
import Head from '../components/Head';
import { headData } from '../mock/data';
import PageWrapepr from '../layout/pageWrapper';
import PageWelcomeBg from '../layout/PageWelcomeBg-section';
import PriceList from '../components/PricesPage-components/PriceList-component';
import '../style/main.scss';

const PricesPage = () => {
  const { title, lang, description } = headData;
  const [StudioMap, setStudioMap] = useState(null);

  useEffect(() => {
    // Dynamically import StudioMap only on client side
    import('../components/Map/StudioMap-component').then((module) => {
      setStudioMap(() => module.default);
    });
  }, []);

  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <title>{title}</title>
        <html lang={lang} />
        <meta name="description" content={description} />
        <meta
          name="google-site-verification"
          content="9kBdSy0tZrplyDlGnpHdAyuPf8AAGzLSZnBTh9EWd7A"
        />
      </Head>
      <PageWrapepr footerLinkTo="#best-offers">
        <PageWelcomeBg overTitle="Best Offers" title="Studio & Chinese Tea Ceremony" />
        <section id="studio-map">
          {StudioMap ? <StudioMap /> : <div style={{ height: '400px' }} />}
        </section>
        <section id="price-list">
          <PriceList type="studio" entrance="massage" />
        </section>
      </PageWrapepr>
    </>
  );
};

export default PricesPage;
